<template>
  <div>
    <div class="flex justify-between items-center flex-wrap mb-1">
      <div>
        <h4 class="mb-0">{{ $t('cancellation.movements_title') }}</h4>
        <small class="text-muted">{{ $t('cancellation.movements_hint') }}</small>
      </div>
      <b-button
        v-permission="'cancellation_movements.edit'"
        variant="primary"
        :disabled="!selected.length"
        @click="processSelected">
        {{ $t('cancellation.process_selected') }}
        <span v-if="selected.length">({{ selected.length }})</span>
      </b-button>
    </div>

    <Grid
      ref="grid"
      :service="service"
      :hide_actions="true"
      route_name="cancellation_movements"
      order_column="opened_at"
      direction="asc">
      <template v-slot:gridThead>
        <vs-th key="select"></vs-th>
        <vs-th key="protocol">{{ $t('cancellation.protocol') }}</vs-th>
        <vs-th key="establishment">{{ $t('cancellation.establishment') }}</vs-th>
        <vs-th key="type">{{ $t('cancellation.movement_type') }}</vs-th>
        <vs-th key="amount">{{ $t('cancellation.amount') }}</vs-th>
        <vs-th key="split">{{ $t('cancellation.split') }}</vs-th>
        <vs-th key="age">{{ $t('cancellation.open_since') }}</vs-th>
        <vs-th key="status">{{ $t('cancellation.status') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="4%" key="select">
            <b-form-checkbox
              :checked="selected.includes(tr.id)"
              :disabled="tr.status === 'DO'"
              @change="toggle(tr.id)"/>
          </vs-td>
          <vs-td width="10%" key="protocol">
            <div>{{ tr.protocol || '—' }}</div>
          </vs-td>
          <vs-td width="15%" key="establishment">
            <div>{{ tr.establishment_name }}</div>
          </vs-td>
          <vs-td width="18%" key="type">
            <div>
              {{ $t('cancellation.movement_type_.' + tr.type) }}
              <span v-if="tr.request && tr.request.reason === 'CL'">· aula cancelada pelo clube</span>
            </div>
          </vs-td>
          <vs-td width="10%" key="amount">
            <div>{{ formatValue(tr.amount) }}</div>
          </vs-td>
          <vs-td width="18%" key="split">
            <div>{{ $t('cancellation.split_.' + tr.split_action) }}</div>
          </vs-td>
          <vs-td width="9%" key="age">
            <vs-chip transparent :color="ageColor(tr.opened_at)" class="text-base">
              {{ ageLabel(tr.opened_at) }}
            </vs-chip>
          </vs-td>
          <vs-td width="16%" key="status">
            <vs-chip transparent :color="statusColor(tr.status)" class="text-base">
              {{ $t('cancellation.movement_status_.' + tr.status) }}
            </vs-chip>
            <!-- Recusa do gateway é informação operacional: sem ela, a linha
                 volta para a fila sem dizer o que houve. -->
            <div v-if="tr.failure_reason" class="text-danger mt-25">
              <small>{{ tr.failure_reason }}</small>
            </div>
            <div v-else-if="tr.gateway_refund_id" class="text-muted mt-25">
              <small>{{ tr.gateway }} · {{ tr.gateway_refund_id }}</small>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton, BFormCheckbox } from 'bootstrap-vue'
import moment from 'moment'
import { currencyFormatter } from '@/util/Util'

import CancellationMovementService from '@/services/api/CancellationMovementService'

export default {
  components: {
    BButton,
    BFormCheckbox
  },
  data: () => ({
    service: null,
    selected: []
  }),
  methods: {
    toggle(id) {
      const index = this.selected.indexOf(id)
      if (index >= 0) {
        this.selected.splice(index, 1)
      } else {
        this.selected.push(id)
      }
    },
    /*
     * "Processar" passou a estornar de verdade no gateway, então o resultado
     * deixou de ser binário: o lote pode voltar com parte executada e parte
     * recusada. Anunciar sucesso a seco escondia exatamente o que o operador
     * precisa ver — de novo, que é como a fila inteira ficava "concluída" sem
     * nenhum dinheiro ter voltado.
     */
    processSelected() {
      this.$vs.loading()
      this.service.process(this.selected).then(
        (response) => {
          const done = this._.get(response, 'processed', 0)
          const failed = this._.get(response, 'failed', 0)

          if (failed && !done) {
            this.notifyError(this.$vs, this.$t('cancellation.process_all_failed'))
          } else if (failed) {
            this.notifyWarning(this.$vs, this.$t('cancellation.process_result', { done, failed }))
          } else {
            this.notifySuccess(this.$vs, this.$t('messages.success'))
          }

          this.selected = []
          this.$refs.grid.fetchGridData(true)
        },
        () => {}
      ).finally(() => { this.$vs.loading.close() })
    },
    formatValue(value) {
      return currencyFormatter(value || 0)
    },
    ageLabel(openedAt) {
      const hours = moment().diff(moment(openedAt), 'hours')
      if (hours < 24) return `${hours} h`
      const days = Math.floor(hours / 24)
      const rest = hours % 24
      return rest ? `${days} d ${rest} h` : `${days} d`
    },
    ageColor(openedAt) {
      const hours = moment().diff(moment(openedAt), 'hours')
      if (hours < 24) return 'success'
      if (hours < 72) return 'warning'
      return 'danger'
    },
    statusColor(status) {
      return {
        AW: 'warning',
        DP: 'danger',
        AN: 'primary',
        PA: 'success',
        DO: 'secondary',
        FA: 'danger'
      }[status] || 'secondary'
    }
  },
  beforeMount() {
    this.service = CancellationMovementService.build(this.$vs)
  }
}
</script>
